/**
 * 同名ファイル競合時の確認モーダル
 * SYSTEM_DESIGN.md §3.1 準拠
 */
export function promptConflict(fileName: string): Promise<'overwrite' | 'cancel'> {
  return new Promise((resolve) => {
    const modalRoot = document.getElementById('modal-root')!;
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay active';

    overlay.innerHTML = `
      <div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="conflict-title">
        <div class="modal-header" style="border-bottom-color: var(--color-warning-bg); background: #fffdf5;">
          <div class="modal-title" id="conflict-title" style="color: #b06000;">
            <span>⚠️</span>
            <span>同名ファイルの競合警告</span>
          </div>
        </div>
        <div class="modal-body">
          <p style="margin-bottom: 16px; font-size: 15px; color: var(--color-text-primary); line-height: 1.5;">
            同名のファイル（<code style="background: #e8eaed; padding: 2px 6px; border-radius: 4px; font-weight: 600;">${fileName}</code>）が既に提出されています。<br>
            上書き（再提出）しますか？
          </p>

          <div style="background: #f1f3f4; border-radius: 6px; padding: 14px; margin-bottom: 12px; font-size: 13px; color: var(--color-text-secondary); line-height: 1.5;">
            <p style="font-weight: 600; color: var(--color-text-primary); margin-bottom: 4px;">🛡️ 旧ファイルは自動保護されます</p>
            「上書きして提出」を選択した場合でも、現在公開されている旧ファイルは自動的に<strong>バックアップ領域へ退避保存</strong>されます。万が一の誤上書きでも教員の管理画面から復旧可能です。
          </div>
        </div>
        <div class="modal-footer">
          <button id="btn-conflict-cancel" class="btn btn-outlined" type="button">
            キャンセル（名前を変える）
          </button>
          <button id="btn-conflict-overwrite" class="btn btn-primary" type="button" style="background-color: #e37400;">
            上書きして提出する
          </button>
        </div>
      </div>
    `;

    modalRoot.appendChild(overlay);

    const cleanup = () => {
      overlay.classList.remove('active');
      setTimeout(() => {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 200);
    };

    overlay.querySelector('#btn-conflict-overwrite')!.addEventListener('click', () => {
      cleanup();
      resolve('overwrite');
    });

    overlay.querySelector('#btn-conflict-cancel')!.addEventListener('click', () => {
      cleanup();
      resolve('cancel');
    });
  });
}
